"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneDeep = void 0;
const fast_copy_1 = __importDefault(require("fast-copy"));
exports.cloneDeep = (object) => fast_copy_1.default(object);
//# sourceMappingURL=clone-deep.js.map